import { render, staticRenderFns } from "./StockProductCategoryPicker.vue?vue&type=template&id=26006379"
import script from "./StockProductCategoryPicker.vue?vue&type=script&lang=js"
export * from "./StockProductCategoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports